module.exports = __webpack_public_path__ + "static/media/otp-code.20915bbb.jpg";